import styles from "./style/timer.module.css";
import stylesMutual from "./style/stylesMutual.module.css";

const Timer = ({ time }) => {
  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  const [m1, m2] = String(minutes).padStart(2, '0');
  const [s1, s2] = String(seconds).padStart(2, '0');

  return (
    <div className={`${stylesMutual.outer} ${styles.timerOuter}`}>
      <div className={styles.timer}>
        <div className={styles.timerChar}>{m1}</div>
        <div className={styles.timerChar}>{m2}</div>
        :
        <div className={styles.timerChar}>{s1}</div>
        <div className={styles.timerChar}>{s2}</div>
      </div>
    </div>
  );
};

export default Timer;
